/** 与用户管理页面「密码规则要求」一致的客户端校验 */

const WEAK_PASSWORDS = new Set([
  '123456',
  'password',
  '12345678',
  'qwerty',
  'admin',
  'admin123',
  'root',
  '111111',
  '123123',
  'abc123',
  '888888',
  '666666',
  '000000',
  'letmein',
  'welcome'
])

/**
 * @param {string} password 明文密码
 * @param {string} username 用户名（不能与密码相同）
 * @returns {string|null} 错误文案，合法则返回 null
 */
export function getPasswordPolicyError(password, username) {
  if (password == null || password === '') {
    return null
  }
  if (password.length < 8) {
    return '密码长度至少 8 位'
  }

  let types = 0
  if (/[A-Z]/.test(password)) types++
  if (/[a-z]/.test(password)) types++
  if (/[0-9]/.test(password)) types++
  if (/[^A-Za-z0-9]/.test(password)) types++
  if (types < 3) {
    return '密码须包含大写字母、小写字母、数字和特殊字符中的至少三种类型'
  }

  if (WEAK_PASSWORDS.has(password.toLowerCase())) {
    return '禁止使用常见弱口令（如 "123456"、"password" 等）'
  }

  const u = username != null ? String(username).trim() : ''
  if (u && password.toLowerCase() === u.toLowerCase()) {
    return '密码不能与用户名相同'
  }

  return null
}
